import { useEffect } from 'react'

import { Button, Grid } from '@mui/material'
import { FormProvider, useForm } from 'react-hook-form'

import { ControlledCheckbox, ControlledDatePicker, ControlledRadioGroup } from 'components/common'
import XeroPurchaseCodesMultipleAutocomplete from 'components/common/custom-queries/XeroCodesMultipleAutocomplete'
import { BatchType } from 'generated/graphql'
import { invoiceBatchFiltersFormVar } from 'graphql/reactiveVariables'

import BatchSearchAutocomplete from './BatchSearchAutocomplete'

export enum BatchFilterCriteria {
  InvoiceDate = 'INVOICE_DATE',
  PaymentDate = 'PAYMENT_DATE',
}

const defaultFormValues = {
  batchSearch: '',
  xeroPurchaseCodes: [],
  dueInStartDate: null,
  dueInEndDate: null,
  dateSelection: BatchFilterCriteria.InvoiceDate,
  newBatchTypeSelection: false,
}

const InvoiceBatchFilterForm = () => {
  const methods = useForm<any>({
    defaultValues: defaultFormValues,
  })

  const {
    control,
    reset,
    formState: { errors },
    handleSubmit,
  } = methods

  const onSubmit = (data: any) => {
    const payload = {
      ...data,
      ...(data.newBatchTypeSelection ? { batchType: BatchType.SupplierGrouped } : {}),
    }
    invoiceBatchFiltersFormVar(payload)
  }

  const clearAll = () => {
    reset(defaultFormValues)
    invoiceBatchFiltersFormVar({ ...defaultFormValues })
  }

  useEffect(() => {
    const invoiceBatchFilterForm = invoiceBatchFiltersFormVar()
    reset(invoiceBatchFilterForm)
  }, [reset])

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <Grid container spacing={1}>
          <Grid item container spacing={2} xs={12} md={10}>
            <Grid item container xs={12} md alignItems='center' justifyContent='center' spacing={2}>
              <Grid item xs={12} md={3}>
                <BatchSearchAutocomplete />
              </Grid>
              <Grid item xs={12} md={3}>
                <XeroPurchaseCodesMultipleAutocomplete control={control} />
              </Grid>
              <Grid item xs={12} md={3}>
                <ControlledDatePicker
                  control={control}
                  name='dueInStartDate'
                  label='Start Date'
                  error={!!errors.startDate}
                  helperText={errors.startDate?.message}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <ControlledDatePicker
                  control={control}
                  name='dueInEndDate'
                  label='End Date'
                  error={!!errors.endDate}
                  helperText={errors.endDate?.message}
                />
              </Grid>
            </Grid>
            <Grid item container xs={12} justifyContent='flex-end' alignItems='center'>
              <Grid item xs={12} md='auto'>
                <ControlledRadioGroup
                  control={control}
                  name='dateSelection'
                  row
                  options={[
                    { value: BatchFilterCriteria.InvoiceDate, label: 'Invoice Date' },
                    { value: BatchFilterCriteria.PaymentDate, label: 'Payment Date' },
                  ]}
                />
              </Grid>

              <Grid item xs={12} md='auto'>
                <ControlledCheckbox
                  control={control}
                  name='newBatchTypeSelection'
                  label='New Batch Type'
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item container xs={12} md={2} spacing={2}>
            <Grid item>
              <Button variant='contained' type='submit'>
                Search
              </Button>
            </Grid>
            <Grid item>
              <Button variant='contained' color='grey' onClick={clearAll}>
                Clear All
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </FormProvider>
  )
}

export default InvoiceBatchFilterForm
